import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import { SxProps } from '@classify/react-core-components/styles';
interface Props {
  children: string;
  sx?: SxProps;
}
export default function TitleSeparator(t0) {
  const $ = _c(7);
  const {
    children,
    sx: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sx = t2;
  let t3;
  if ($[2] !== sx) {
    t3 = {
      mb: 2,
      ...sx
    };
    $[2] = sx;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <Typography variant="h5" component="h2" sx={t3}>{children}</Typography>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}